import { gql } from '@apollo/client';
import { ResponsiveImageFragment } from './responsive-image';
import { CategoryInformationBlock } from './category-information';

const Category = gql`
    fragment Category on CategoryRecord {
        __typename
        id
        title
        fullSlug
        visible
        color
        image {
            alt
            title
            responsiveImage(imgixParams: { fm: png, fit: clip, auto: [compress], w: 372, h: 250 }) {
                ...ResponsiveImageFragment
            }
        }
        information {
            ...CategoryInformationBlock
        }
        parent {
            title
            fullSlug
            parent {
                title
                fullSlug
            }
        }
    }
    ${ResponsiveImageFragment}
    ${CategoryInformationBlock}
`;
export default Category;
